module.exports = __webpack_public_path__ + "static/media/ff_tags.ccc5427b.png";